module.exports = __webpack_public_path__ + "img/PINK.2de4f0e4.svg";